




































import Vue, { PropOptions } from 'vue';

export type QuoteCardType = Blok & {
  userImage?: { filename: string; alt: string };
  userFullName: string;
  userNickname: string;
  socialMediaIcon?: string;
  text: string;
  showUserNickname?: boolean;
  showUserImage?: boolean;
  showBadge?: boolean;
  showSocialMediaIcon?: boolean;
};

export default Vue.extend({
  props: {
    blok: {
      type: Object,
      required: true,
    } as PropOptions<QuoteCardType>,
  },
  computed: {
    socialMediaIconPath(): string {
      if (!this.blok.socialMediaIcon) {
        return '';
      }
      return `/social-media-icons/${this.blok.socialMediaIcon}.png`;
    },
  },
});
